import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/pro-solid-svg-icons';
import { Currencies } from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';
import type { CargoDetails } from '@api/features/cargos/getCargoDetails';
import NumericInput from '@client/components/NumericInput';
import Button from '@client/components/Button';
import styles from '../styles/shared.module.css';
import PortCostPopover from '../PortCostPopover';
import HistoricalPortCostModal from '../HistoricalPortCostModal';
import { LocalPortRotation } from '../context/hooks/usePortRotationHandlers';

type Props = {
	record: LocalPortRotation;
	disabled?: boolean;
	currency: Values<typeof Currencies>;
	cargos: CargoDetails[];
	isRequiredHighlightBorder: boolean;
	displayPortCost: number;
	onValueChange: (val: number | null) => void;
	onPortRotationRowChange: (id: number, attributes: any) => void;
	shortcut?: string;
};

const PortDACellWithHistory = ({
	record,
	disabled,
	currency,
	cargos,
	isRequiredHighlightBorder,
	displayPortCost,
	onValueChange,
	onPortRotationRowChange,
	shortcut,
}: Props) => {
	const [historyOpen, setHistoryOpen] = useState(false);
	const port = record.port;

	return (
		<>
			<NumericInput
				data-testid={'port-cost'}
				data-shortcut={shortcut}
				isRequiredHighlightBorder={isRequiredHighlightBorder}
				key={record.id}
				disabled={disabled}
				value={displayPortCost}
				onChange={onValueChange}
				className={styles.currencyPopoverBtn}
				addonBefore={(
					<PortCostPopover
						type="portCost"
						portRotationId={record.id}
						currency={currency}
						disabled={disabled}
					/>
				)}
				addonAfter={port ? (
					<Button
						style={{ width: 16, padding: 0 }}
						type="link"
						size="small"
						disabled={disabled}
						onClick={() => setHistoryOpen(true)}
						icon={<FontAwesomeIcon icon={faBook} />}
						data-testid="historical-port-cost-btn"
					/>
				) : undefined}
			/>
			{port && (
				<HistoricalPortCostModal
					open={historyOpen}
					onClose={() => setHistoryOpen(false)}
					record={record}
					port={port}
					disabled={disabled}
					cargos={cargos}
					onPortRotationRowChange={onPortRotationRowChange}
				/>
			)}
		</>
	);
};

export default PortDACellWithHistory;
